import React, {Component} from "react";
import {connect} from "react-redux";
import CapNameTable from "./CapNameTable";
import {reloadCapNames,} from "../../../../actions/capNamesActions";


class CapContent extends Component {

    render() {
        return <>
            <br/>
            <p>В ПК и ротатор из трекера будут импортированы только капы, добавленные в данную таблицу. </p>
            <p>Все столбцы обязательны для заполнения. </p>
            <CapNameTable/>
            <div>
                <div className="circle-btn-group" style={{position: "absolute", bottom: "0", backgroundColor: "white"}}>
                    <button className={"circle-btn"}
                            title="Синхронизировать данные с трекером"
                            onClick={() => this.props.reloadCapNames()}><i
                        className="ti ti-reload"/></button>
                </div>
            </div>
        </>
    }
}

export default connect(null, {reloadCapNames})(CapContent);